import { render, staticRenderFns } from "./stfsySet.vue?vue&type=template&id=1308fe37&scoped=true&"
import script from "./stfsySet.vue?vue&type=script&lang=js&"
export * from "./stfsySet.vue?vue&type=script&lang=js&"
import style0 from "./stfsySet.vue?vue&type=style&index=0&id=1308fe37&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1308fe37",
  null
  
)

export default component.exports